import {
  Component,
  ComponentRef,
  ViewContainerRef,
  ResolvedReflectiveProvider,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  Renderer
} from '@angular/core';

import { BaseDynamicComponent } from './base-dynamic-component';
import { DialogRef } from '../models/dialog-ref';
import { Class } from '../framework/utils';
/**
 * A component that acts as a top level container for an open modal window.
 */
export class CSSDialogContainer extends BaseDynamicComponent {
/**
 * @param {?} dialog
 * @param {?} el
 * @param {?} renderer
 */
constructor(public dialog: DialogRef<any>,
              el: ElementRef, renderer: Renderer) {
    super(el, renderer);
    this.activateAnimationListener();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'css-dialog-container',
  host: {
    'tabindex': '-1',
    'role': 'dialog'
  },
  encapsulation: ViewEncapsulation.None,
  template: `<ng-content></ng-content>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
{type: ElementRef, },
{type: Renderer, },
];
}

function CSSDialogContainer_tsickle_Closure_declarations() {
/** @type {?} */
CSSDialogContainer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CSSDialogContainer.ctorParameters;
/** @type {?} */
CSSDialogContainer.prototype.dialog;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
